import { Heart, Sparkles, Flame } from "lucide-react";
import { t, tf } from "@/lib/i18n";
import { useSite } from "@/context/SiteContext";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import FinalCta from "@/components/home/FinalCta";

const VALUES = [
  { icon: Heart, word: "Kind.", body: "Respect for every person in the chain — the family giving scrap and the kabadiwala collecting it." },
  { icon: Sparkles, word: "Clean.", body: "Cleaner homes, cleaner lanes and clean, honest dealings with clear rates and fair weighing." },
  { icon: Flame, word: "Bold.", body: "Starting small in one city, with the patience to grow carefully and do it right." },
];

export default function About() {
  const { content: c } = useSite();
  return (
    <div data-testid="about-page">
      <PageHeader testid="about-header" eyebrow="About Kindsaver" title={c.about_title} subtitle={c.about_body} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-7">
          <img src={c.image_about} alt={t("Doorstep scrap pickup in Jaipur")} className="rounded-[32px] w-full object-cover aspect-[16/10]" />
        </Reveal>
        <Reveal delay={120} className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <img src="/icon-192.png" alt={t("Kindsaver logo")} className="w-20 h-20 rounded-full shadow-lg" />
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[var(--leaf)]">{t("Phase one")}</div>
          </div>
          <h2 className="mt-5 text-3xl sm:text-4xl font-bold leading-tight">{tf("Connecting citizens with local kabadiwalas in {city}.", { city: c.launch_city })}</h2>
          <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">{t("That's our whole focus right now. We'd rather do one thing well — reliable pickups, clear rates and respectful service — before we do anything more.")}</p>
          <p className="mt-4 text-[var(--ink-soft)] leading-relaxed">{t("If you'd like to see Kindsaver in your city, or want to work with us, we'd love to hear from you.")}</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-5">
        {VALUES.map(({ icon: Icon, word, body }, i) => (
          <Reveal key={t(word)} delay={i * 100} className="rounded-3xl bg-white border border-[rgba(20,40,26,.08)] p-8 card-lift" data-testid={`about-value-${i}`}>
            <Icon className="text-[var(--marigold)]" size={28} />
            <div className="mt-4 font-display text-4xl font-extrabold text-[var(--leaf)]">{t(word)}</div>
            <p className="mt-3 text-[var(--ink-soft)] leading-relaxed">{t(body)}</p>
          </Reveal>
        ))}
      </section>
      <FinalCta />
    </div>
  );
}
